/* JD9 — auto-close facet panel SOLO DESKTOP (mobile invariato) */
(function () {
  // Dawn/derivati: mobile < 990px circa
  function isMobile() {
    return window.matchMedia("(max-width: 989px)").matches;
  }

  document.addEventListener(
    "change",
    function (e) {
      const t = e.target;

      // Considera solo elementi dentro le faccette
      const inFacetForm = t.closest(
        "facet-filters-form, .facets-container, .facets__form"
      );
      if (!inFacetForm) return;

      // SE MOBILE → NON fare nulla (comportamento originale del tema)
      if (isMobile() || t.closest(".mobile-facets__wrapper, menu-drawer.facets__drawer")) {
        return;
      }

      // Desktop: chiudi il <details> del filtro che hai appena toccato
      const isChoice =
        (t.tagName === "INPUT" && (t.type === "checkbox" || t.type === "radio")) ||
        t.tagName === "SELECT";

      if (!isChoice) return;

      const details = t.closest("details");
      if (details && details.hasAttribute("open")) {
        // breve delay per permettere al tema di aggiornare URL/DOM
        setTimeout(function () {
          try {
            details.open = false;
            const summary = details.querySelector("summary");
            if (summary) summary.focus({ preventScroll: true });
          } catch (_) {}
        }, 80);
      }
    },
    { passive: true }
  );
})();


